export default {"src":"/_next/static/media/Folder.435c2840.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};